<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置登录后页面头部，为公共组件
 -->
<template>
    <div class="comp-header comp">
        <div class="container">
            <div class="header-box">
                <div class="logo">
                    <img v-if="companyInfo.companylogo" :src="$util.src('/common/download',{id:companyInfo.companylogo})" height="41" v-on:click.prevent="$router.push({name:'login'})">
                    <div v-if="tit" class="tit">
                        {{ tit }}
                    </div>
                </div>
                <ul class="links">
                    <template v-if="links.length>0">
                        <li v-for="link in links" :key="link.n">
                            <a :href="link.u" target="_blank" :title="link.n">
                                <i :class="link.i" /> {{ link.n }}</a>
                        </li>
                    </template>
                    <li v-if="login">
                        <a href="javascript:void(0)" title="安全退出" v-on:click="logoff">
                            <i class="fa fa-power-off" /> 安全退出</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "HeaderCom",
    props: {
        tit: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            name: "",
            login: false,
            links: [],
            companyInfo: {}
        };
    },
    created () {
        this.companyInfo = this.$cache.getCompanyInfo();
        if (this.companyInfo && this.companyInfo.companyheardlink) {
            this.links = JSON.parse(this.companyInfo.companyheardlink || "[]");
            this.name = this.companyInfo.companyname;
        }
        this.login = this.$store.state.login.status;
        document.title = this.companyInfo.companyname || this.$route.meta.nameText;
    },
    methods: {
        logoff () {
            const _this = this;
            this.$util.request("common/logout", {}, false, false).then(res => {
                if (res.data) {
                    _this.$store.dispatch("logout", res.data[0]).then(() => {
                        _this.$router.replace("/");
                        sessionStorage.removeItem("giveupbind");
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
.comp-header {
    min-width: 1200px;
    .container {
        position: relative;
        height: 100%;
        .header-box {
            height: 80px;
        }
        .logo {
            display: inline-block;
            padding-top: 15px;
            .tit {
                display: inline-block;
                font-size: 22px;
				min-width: 200px;
            }
            .tit:before {
                content: "";
                margin: 0 18px;
            }
            img {
                // width: 195px;
                vertical-align: middle;
                height: 50px;
            }
        }
        .links {
            position: absolute;
            right: 0;
            top: 30px;
            li {
                display: inline-block;
                margin-left: 10px;
            }
        }
    }
}
</style>
